import React, { useContext } from 'react'
import { EPCRContext } from '../EPCR'
import Stack from '@mui/material/Stack'
import ResponseTimes from './ResponseTimes'
import Details from './Details'
import NextButton from '../NextButton'
import HealthSafety from './HealthSafety/HealthSafety'

const IncidentModule = () => {
  const { formValues } = useContext(EPCRContext)

  return (
    <Stack gap={2}>
      <Details />
      {formValues?.incident?.incidentType === 'Event' && <HealthSafety />}
      {!formValues?.incident?.cadIncident && (
        <ResponseTimes formValues={formValues} />
      )}
      <NextButton newModule="Demographics" />
    </Stack>
  )
}

export default IncidentModule
